var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    fill: "currentColor",
    strokeWidth: 0,
    role: "img",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7801_3655)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2033 2H7.26231V8.4387H10.2033V2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1655 2H13.2245V8.4387H16.1655V2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0639 21.9776C6.51442 21.9776 2 17.4632 2 11.9138H4.94096C4.94096 15.8409 8.13588 19.0366 12.0639 19.0366C15.9918 19.0366 19.1868 15.8417 19.1868 11.9138V2H22.1277V11.9138C22.1277 17.4632 17.6133 21.9776 12.0639 21.9776Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7801_3655"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 23.821,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEd);
export default __webpack_public_path__ + "static/media/ed.5970db81a160942c5f4bc0e3e375c3f2.svg";
export { ForwardRef as ReactComponent };